import { render, staticRenderFns } from "./SortableBucketTile.vue?vue&type=template&id=616641a2"
import script from "./SortableBucketTile.vue?vue&type=script&lang=js"
export * from "./SortableBucketTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports